<template>
    <div>
        <Modal @onConfirm="onConfirm"
            @onClose="onClose"
            @onOpen="onOpen"
            :isOpen="isOpen"
            :modalTitle="currentPosition.name"
            :confirmLabel="false"
            :cancelLabel="$t('layouts.global.close')"
            class="skills_compare_modal">

            <RadarChart :chartData="chartDatas" :labels="labels" />

        </Modal>
    </div>
</template>

<script>

import RadarChart from './skillsCompareChart'

export default {
    name: 'SkillsCompareModal',
    props: ['opened', 'evaluations', 'selectedEvaluationsIds', "BaseSkillData", "skillsKey"],
    components: {
        RadarChart
    },
    mounted(){},
    data(){
        return {
            isOpen: false,
            chartDatas: [],
            label: [],
            colors: ['#898AC9',  '#D94999', '#2FCBBF', '#374654', '#898AC9','#CEAE47' ]
        }
    },
    computed: {
        labels(){
            return Object.values(this.BaseSkillData).map(x => x.name[this.$i18n.locale])
        },
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        SelectedEvaluations(){
                return this.evaluations.filter((evaluation) => {
                    return this.selectedEvaluationsIds.includes(evaluation.id)
                })
        }
    },
    methods: {
        onOpen(){
            const refScores = Object.values(this.BaseSkillData).map(x => x.ref_score.toFixed(0))
            this.chartDatas = []
            this.chartDatas.push({
                label: 'referentiel',
                data: refScores,
                lineTension: 0.1,
                borderColor: "rgba(150, 150, 150, 0) ",
                backgroundColor: "rgba(150, 150, 150, 0.35) ",
                pointRadius: 0
            })
            this.SelectedEvaluations.forEach((evaluation, index) => {
                const scores = Object.values(evaluation.saven_test[this.skillsKey]).map(x => x.score.toFixed(0))
                this.chartDatas.push({
                    label: evaluation.candidate_username,
                    data: scores,
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: "#ffffff",
                    borderColor: this.colors[index],
                    pointRadius: 0
                })
            })
        },
        onConfirm(){
            this.$emit('closeSendReport')
        },
        onClose(){
            this.isOpen = false
            this.$emit('closeSendReport')
            this.confirmDisabled = true
            this.isStep1 = true
        }

    },
    watch: {
        'opened': {
            handler: function(newVal, oldVal){
                this.isOpen = newVal
            }
        }
    }
}
</script>

<style lang="scss" >
    .skills_compare_modal{
        text-align: left;
        .modal-card{
            width: 100%;
            max-width: 900px;
        }
    }
</style>